/**
 * Application-wide identity constants.
 * Update this file when the product name changes — nowhere else.
 */
export const APPLICATION_NAME       = 'Seiko Inventory and Sales Management System';
export const APPLICATION_SHORT_NAME = 'Seiko IMS';
